import { historyItemStrategy } from './history.const';

const getDiffWordIndex = (newTermWords: string[], lastTermWords: string[]) => {
  let indexDiffWord = 0;

  newTermWords.some((newTermPart, index) => {
    if (newTermPart !== lastTermWords[index]) {
      indexDiffWord = index;
      return true;
    }
  });

  return indexDiffWord;
};

export const getHistoryItemStrategy = (newTerm: string, lastTerm: string): historyItemStrategy => {
  const newTermWords = newTerm.split(' ');
  const lastTermWords = lastTerm?.split(' ') ?? [];
  const diffWordIndex = getDiffWordIndex(newTermWords, lastTermWords);

  /*
   * 1º) Replace
   *  Terms are the same or last word of the term is different and more specific than the last stored
   *  Refine query
   * 2º) None
   *  Deleting in a single word of the term
   *  Deleting query with delete key
   * 3º) Add
   *  Default
   *  Rest of the use cases
  */
  if (lastTerm === newTerm ||
    diffWordIndex === (lastTermWords.length - 1) && newTermWords[diffWordIndex].includes(lastTermWords[diffWordIndex])) {
    return historyItemStrategy.replace;
  }
  if (lastTerm?.includes(newTerm) && newTermWords.length === lastTermWords.length) {
    return historyItemStrategy.none;
  }
  return historyItemStrategy.add;
};
